export type TeaserContent = {
  title?: string
  descriptionHtml?: string
}

// Trix has one heading level, so the first heading is the title.
export const parseTeaserContent = (html: string): TeaserContent => {
  const body = new DOMParser().parseFromString(html, 'text/html').body

  const heading = body.querySelector('h1')
  const title = heading?.textContent?.trim() || undefined
  heading?.remove()

  const descriptionHtml = body.textContent?.trim() ? body.innerHTML.trim() : undefined

  return { title, descriptionHtml }
}
